import { AppConfigModel } from "../abstract/app-config.model";

export class ProductType extends AppConfigModel {

    static override CLASS_NAME: string = 'ProductType';
}
